var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { useEntity } from '../../hooks/use-entity';
import { classNames } from '../../utils/cn';
var cls = classNames('slice-header');
export var SliceHeaderDefaultProps = {
  showTopDivider: false,
  showBottomDivider: true,
  borderColor: 'dark'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: 300;\n    font-size: 2.5em;\n    text-align: center;\n    font-family: ", ";\n    margin: 0;\n    line-height: 1.15em;\n  "], ["\n    font-weight: 300;\n    font-size: 2.5em;\n    text-align: center;\n    font-family: ", ";\n    margin: 0;\n    line-height: 1.15em;\n  "])), theme.FONT('serif'))
}); // -------- Components -------->

var My = {
  Container: styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var SliceHeader = function SliceHeader(props) {
  var className = props.className;
  var entity = useEntity(props.entity);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, entity.title || entity.name);
};
SliceHeader.defaultProps = SliceHeaderDefaultProps;
SliceHeader.cls = cls;
var templateObject_1, templateObject_2;